module.exports = __webpack_public_path__ + "img/school_csmd2.f5994587.png";